import AuthAPI from '../api/Auth';
import Cookies from 'js-cookie';

export default class Session {

	static cookie = Cookies.getJSON('auth.response.user');

	static RefreshCredentials(){
		this.cookie = Cookies.getJSON('auth.response.user');
	}

	static GetUsuarioLembrete(){
		return Cookies.getJSON('auth.screen.user');
	}

    static LoginSucesso(rs) {
		Cookies.set('auth.response.user', rs, { expires: 1 });
		Cookies.set('auth.screen.user', rs.usuario.email, { expires: 31 });
    }

    static GetToken() {
		if( this.cookie !== undefined ){
			return this.cookie.token;
		}
		return false;
    }

    static GetVinculo(){

		if (this.cookie !== undefined && this.cookie.usuario.is_master){
			return Cookies.getJSON('auth.response.admin.cliente');
		}
		if( this.cookie !== undefined ) {
			return this.cookie.vinculo;
		}

		return [];
	}

	static GetUsuario(){
		if( this.cookie !== undefined ) {
			return this.cookie.usuario;
		}
		return false;
	}

	static IsMaster(){

		if( this.cookie !== undefined ) {
			return this.cookie.usuario.is_master;
		}
		return undefined;
	}

    static ValidaToken() {
		return AuthAPI.status();
    }

    static FecharSessao() {
		let rs = AuthAPI.sair();
		if( rs ) {
			Cookies.remove('auth.response.user');
			Cookies.remove('auth.response.admin.cliente');
			return true;
		}
        return false;
	}

	static SetVinculoAdmin(rs) {
		Cookies.set('auth.response.admin.cliente', { cliente: rs });
	}

}



// WEBPACK FOOTER //
// ./src/services/auth/Session.js